import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

type PermitTrackingCreateDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  onTitleChange: (value: string) => void;
  applicationNumber: string;
  onApplicationNumberChange: (value: string) => void;
  applicantName: string;
  onApplicantNameChange: (value: string) => void;
  projectAddress: string;
  onProjectAddressChange: (value: string) => void;
  notes: string;
  onNotesChange: (value: string) => void;
  deadline: string;
  onDeadlineChange: (value: string) => void;
  saving: boolean;
  onSubmit: () => void;
};

export function PermitTrackingCreateDialog({
  open,
  onOpenChange,
  title,
  onTitleChange,
  applicationNumber,
  onApplicationNumberChange,
  applicantName,
  onApplicantNameChange,
  projectAddress,
  onProjectAddressChange,
  notes,
  onNotesChange,
  deadline,
  onDeadlineChange,
  saving,
  onSubmit,
}: PermitTrackingCreateDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Add permit application</DialogTitle>
          <DialogDescription>
            Track a permit moving through your review pipeline.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="permit-title">Title</Label>
            <Input
              id="permit-title"
              value={title}
              onChange={(event) => onTitleChange(event.target.value)}
              placeholder="e.g. 123 Main St building permit"
            />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor="permit-app-number">Application number</Label>
              <Input
                id="permit-app-number"
                value={applicationNumber}
                onChange={(event) => onApplicationNumberChange(event.target.value)}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="permit-deadline">Deadline</Label>
              <Input
                id="permit-deadline"
                type="date"
                value={deadline}
                onChange={(event) => onDeadlineChange(event.target.value)}
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="permit-applicant">Applicant</Label>
            <Input
              id="permit-applicant"
              value={applicantName}
              onChange={(event) => onApplicantNameChange(event.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="permit-address">Project address</Label>
            <Input
              id="permit-address"
              value={projectAddress}
              onChange={(event) => onProjectAddressChange(event.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="permit-notes">Notes</Label>
            <Textarea
              id="permit-notes"
              value={notes}
              onChange={(event) => onNotesChange(event.target.value)}
              rows={3}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={onSubmit} disabled={!title.trim() || saving}>
            {saving ? "Saving…" : "Add permit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
